import React from 'react';
import { useNavigate } from 'react-router-dom';

interface StaffMember {
  Name?: string;
  Area?: string;
  Project?: string;
  Reason?: string;
}

interface PerformanceGapCardProps {
  staff: StaffMember | string;
}

const PerformanceGapCard: React.FC<PerformanceGapCardProps> = ({ staff }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (typeof staff === 'object' && staff.Name && staff.Area) {
      if (staff.Area === 'Development') {
        // Navigate to DevelopmentDevelopers page with preselected developer and project
        navigate('/development/developers', {
          state: {
            selectedDeveloperName: staff.Name,
            selectedProjectName: staff.Project
          }
        });
      } else if (staff.Area === 'Support') {
        // Navigate to SupportTeamMembers page with preselected member
        navigate('/support/team-members', {
          state: {
            selectedMember: staff.Name
          }
        });
      }
    }
  };

  const isClickable = typeof staff === 'object' && staff.Name && staff.Area;

  return (
    <li 
      style={{ 
        marginBottom: '0.75rem', 
        padding: '0.75rem',
        borderBottom: '1px solid #f7fafc',
        color: '#2d3748',
        lineHeight: '1.5',
        background: '#fef5e7',
        borderRadius: '6px',
        cursor: isClickable ? 'pointer' : 'default',
        transition: 'background-color 0.2s ease',
      }}
      onClick={handleClick}
      onMouseEnter={(e) => {
        if (isClickable) {
          e.currentTarget.style.backgroundColor = '#fde68a';
        }
      }}
      onMouseLeave={(e) => {
        if (isClickable) {
          e.currentTarget.style.backgroundColor = '#fef5e7';
        }
      }}
    >
      <div style={{ fontWeight: '600', color: '#1a202c', marginBottom: '0.25rem' }}>
        {typeof staff === 'string' ? staff : staff.Name}
      </div>
      {typeof staff === 'object' && staff.Area && (
        <div style={{ fontSize: '0.9rem', color: '#4a5568' }}>
          {staff.Area}
        </div>
      )}
      {typeof staff === 'object' && staff.Project && (
        <div style={{ fontSize: '0.9rem', color: '#4a5568' }}>
          {staff.Project}
        </div>
      )}
      {typeof staff === 'object' && staff.Reason && (
        <div style={{ fontSize: '0.9rem', color: '#4a5568' }}>
          {staff.Reason}
        </div>
      )}
    </li>
  );
};

export default PerformanceGapCard;
